export const InactiveGreen = () => {
    return (
        <svg aria-hidden width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_8410_87)">
                <path
                    d="M12.5059 24C19.134 24 24.5059 18.6281 24.5059 12C24.5059 5.37188 19.134 0 12.5059 0C5.87773 0 0.505859 5.37188 0.505859 12C0.505859 18.6281 5.87773 24 12.5059 24ZM12.5199 15.5531C15.2902 15.5531 17.8684 15.0562 20.0293 14.1937C19.2699 17.6578 16.1949 20.25 12.5199 20.25C8.84492 20.25 5.76992 17.6578 5.01055 14.1937C7.17617 15.0516 9.7543 15.5531 12.5199 15.5531ZM10.2746 9.75C10.2746 10.5797 9.6043 11.25 8.77461 11.25C7.94492 11.25 7.27461 10.5797 7.27461 9.75C7.27461 8.92031 7.94492 8.25 8.77461 8.25C9.6043 8.25 10.2746 8.92031 10.2746 9.75ZM16.2746 11.25C15.4449 11.25 14.7746 10.5797 14.7746 9.75C14.7746 8.92031 15.4449 8.25 16.2746 8.25C17.1043 8.25 17.7746 8.92031 17.7746 9.75C17.7746 10.5797 17.1043 11.25 16.2746 11.25Z"
                    fill="#1A1E21"
                    fillOpacity="0.26"
                />
            </g>
            <defs>
                <clipPath id="clip0_8410_87">
                    <rect width="24" height="24" fill="white" transform="translate(0.505859)" />
                </clipPath>
            </defs>
        </svg>
    );
};
